import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFolder = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_3260_63423)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M1.89062 19.5547C0.765625 19.5547 -0.109375 18.6797 -0.109375 17.5547V5.55469C-0.109375 4.47135 0.765625 3.55469 1.89062 3.55469H7.97396C8.34896 3.55469 8.68229 3.72135 8.93229 3.97135L11.224 6.22135H19.224C20.3073 6.22135 21.224 7.13802 21.224 8.22135V8.88802H22.2779C23.4064 8.88802 24.1853 9.97918 23.7836 10.9973L20.8022 18.5529C20.5642 19.1561 19.9651 19.5547 19.2965 19.5547H1.89062ZM7.97396 4.88802L10.2656 7.17969C10.5156 7.42969 10.849 7.55469 11.224 7.55469H19.224C19.5573 7.55469 19.8906 7.88802 19.8906 8.22135V8.88802H5.37364C4.70507 8.88802 4.10595 9.28663 3.86794 9.88981L1.22396 16.5903V5.55469C1.22396 5.22135 1.51562 4.88802 1.89062 4.88802H7.97396ZM2.39226 18.2214H19.224C19.2878 18.2214 19.3516 18.2107 19.4131 18.1907C19.4572 18.1657 19.4925 18.1266 19.5116 18.0782L22.493 10.5227C22.5504 10.3772 22.4391 10.2214 22.2779 10.2214H5.37364C5.27813 10.2214 5.19254 10.2783 5.15854 10.3645L2.17716 17.92C2.11977 18.0655 2.23104 18.2214 2.39226 18.2214Z"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_3260_63423",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgFolder);
export { ForwardRef as ReactComponent };
